import './App.css';
import React from 'react';
import { Routes, Route, Navigate } from "react-router-dom";

// Phase 2 - Public Routes
import LandingPage from './pages/index';
import Service from './pages/ServicesPage';
import Contact from './pages/ContactPage';
import About from './pages/AboutPage';
import Profile from './pages/ProfilePage';
import Tracking from './pages/tracking';

import ConsultationRequest from './pages/ConsultationRequest';


function App() {
  return (
    <div>
      <Routes>
        {/* Default redirect */}
        {/* <Route path="*" element={<Navigate to="/" replace />} /> */}

        {/* Phase 2 - Public Routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/services" element={<Service />} />
        <Route path="/tracking" element={<Tracking />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/quote" element={<Contact />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/consultations" element={<ConsultationRequest />} />
      </Routes>
    </div>
  );
}

export default App;